import { useEffect } from "react";

/**
 * Sets page title, meta description, og tags, and canonical URL.
 * Works with Googlebot (which renders JS) — no SSR needed.
 */
export default function useSEO({ title, description, keywords = "", canonical = "" }) {
  useEffect(() => {
    // Title
    document.title = title;

    // Helper to upsert a <meta> tag
    function setMeta(selector, attr, value) {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [attrName, attrVal] = attr.split("=");
        el.setAttribute(attrName, attrVal.replace(/"/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    }

    setMeta('meta[name="description"]', 'name=description', description);
    if (keywords) setMeta('meta[name="keywords"]', 'name=keywords', keywords);

    // Open Graph
    setMeta('meta[property="og:title"]', 'property=og:title', title);
    setMeta('meta[property="og:description"]', 'property=og:description', description);
    setMeta('meta[property="og:type"]', 'property=og:type', "website");

    // Canonical
    const base = "https://celestial-guide-78.emergent.host";
    const href = canonical ? `${base}${canonical}` : base;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
  }, [title, description, keywords, canonical]);
}
